import { render, staticRenderFns } from "./RecepientsListForEditor.vue?vue&type=template&id=5ad406c1&"
import script from "./RecepientsListForEditor.vue?vue&type=script&lang=js&"
export * from "./RecepientsListForEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
